import { useState } from "react"
import { Editor } from "@tiptap/react"
import {
  Button,
  HStack,
  Icon,
} from "@chakra-ui/react"
import {
  FaWandMagicSparkles,
  FaFeather,
  FaSpellCheck,
} from "react-icons/fa6"

import { LanguageMenu } from "@/components/tiptap/bubbleMenu/LanguageMenu"
// import { PromptInput } from "@/components/tiptap/bubbleMenu/PromptInput"

export function BubbleMenuContent({
  editor,
  onAction,
}: {
  editor: Editor
  onAction: (
    action: "summarize" | "enrich" | "checkGrammar" | "translate" | "generateQuestions",
    selectedText: string,
    langCode?: string
  ) => void | Promise<void>
}) {
  const [loadingAction, setLoadingAction] = useState<null | string>(null)

  const getSelectedText = () =>
    editor.state.doc.textBetween(
      editor.state.selection.from,
      editor.state.selection.to,
      " "
    ).trim()

  const handleClick = async (
    action: "summarize" | "enrich" | "checkGrammar" | "translate" | "generateQuestions",
    langCode?: string
  ) => {
    const text = getSelectedText()
    if (!text) return

    setLoadingAction(action + (langCode || ""))
    try {
      await onAction(action, text, langCode)
    } finally {
      setLoadingAction(null)
    }
  }

  const busy = !!loadingAction

  return (
    <HStack gap={2} className="ai-bubble-menu">
      <Button
        variant="ghost"
        size="sm"
        colorScheme="blue"
        loading={loadingAction === "summarize"}
        disabled={busy && loadingAction !== "summarize"}
        loadingText="요약 중"
        spinnerPlacement="start"
        onClick={() => handleClick("summarize")}
      >
        <Icon as={FaWandMagicSparkles} fontSize="16px" mr={1} />
        요약
      </Button>

      <Button
        variant="ghost"
        size="sm"
        colorScheme="blue"
        loading={loadingAction == "enrich"}
        disabled={busy && loadingAction !== "enrich"}
        onClick={() => handleClick("enrich")}
      >
        <Icon as={FaFeather} fontSize="16px" mr={1} />
        보강
      </Button>

      <Button
        variant="ghost"
        size="sm"
        colorScheme="blue"
        loading={loadingAction === "checkGrammar"}
        disabled={busy && loadingAction !== "checkGrammar"}
        loadingText="검사 중"
        spinnerPlacement="start"
        onClick={() => handleClick("checkGrammar")}
      >
        <Icon as={FaSpellCheck} fontSize="16px" mr={1} />
        맞춤법
      </Button>

      {/* 🌐 Multi-language Translate */}
      <LanguageMenu
        loading={loadingAction?.startsWith("translate")}
        disabled={busy && !loadingAction?.startsWith("translate")}
        onSelect={(langCode) => handleClick("translate", langCode)}
      />

      {/* <PromptInput
        loading={loadingAction === "generateQuestions"}
        onSubmit={(text) => handleClick("generateQuestions", text)}
      /> */}

    </HStack>
  )
}
